var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('memlist-static-table',{ref:"memberTable",attrs:{"id":"member-table","fields":_vm.fields,"items":_vm.items,"head-variant":"light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }